import {
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Helmet } from "react-helmet-async";
import { useEffect, useMemo, useState } from "react";
import { FaFileAlt, FaPaperclip, FaTicketAlt } from "react-icons/fa";
import { IoIosArrowRoundBack, IoMdClose } from "react-icons/io";
import { IoAddSharp, IoRepeatOutline, IoSearch } from "react-icons/io5";
import { MdDateRange } from "react-icons/md";
import DatePicker from "react-multi-date-picker";
import { Cancel, Send2 } from "../../../assets";
import { fixNumbers } from "../../../core/utils";
import {
  ChatItem,
  CustomModal,
  Dropdown,
  Input,
  Layout,
  MyButton,
  Textarea,
} from "../../components";
import { DetailsTicketController } from "../../controllers";

const END_DATE_FORMAT = "YYYY/MM/DD";

function formatEndDateInput(raw: string): string {
  const digits = fixNumbers(raw).replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 4) {
    return digits;
  }
  if (digits.length <= 6) {
    return `${digits.slice(0, 4)}/${digits.slice(4)}`;
  }
  return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/${digits.slice(6, 8)}`;
}

function downloadFile(file: any) {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file?.name || "file";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function CustomInput({
  onFocus,
  value,
  onChange,
  title,
  emptyState,
  error,
}: any) {
  return (
    <Input
      emptyState={emptyState}
      hideEndAdornment
      type="number"
      error={error}
      onChange={onChange}
      customFocus={onFocus}
      myStyle="w-100"
      title={title}
      value={value}
      icon={<MdDateRange />}
    />
  );
}

function EndDateInput({ onFocus, value, onChange, title, error }: any) {
  const handleChange = (e: any) => {
    const formatted = formatEndDateInput(e.target.value);
    onChange({ ...e, target: { ...e.target, value: formatted } });
  };

  return (
    <Input
      hideEndAdornment
      error={error}
      onChange={handleChange}
      customFocus={onFocus}
      myStyle="w-100"
      title={title}
      value={value || ""}
      placeholder={END_DATE_FORMAT}
      max="10"
      icon={<MdDateRange />}
    />
  );
}

function ErjaaMenu({
  open,
  onClose,
  anchorEl,
  assignPersonsList,
  onAssign,
}: any) {
  // local search state — typing only re-renders this menu, never the whole page
  const [term, setTerm] = useState("");
  const filtered = useMemo(() => {
    if (!term) return assignPersonsList || [];
    return (assignPersonsList || []).filter((item: any) =>
      String(item?.title || "").toLowerCase().includes(term.toLowerCase())
    );
  }, [term, assignPersonsList]);

  // fresh list every time the dropdown opens
  useEffect(() => {
    if (open) setTerm("");
  }, [open]);

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      className="erjaa-menu"
      disableAutoFocusItem
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <div className="erjaa-menu-search">
        <IoSearch className="erjaa-menu-search-icon" />
        <input
          autoFocus
          className="erjaa-menu-search-input"
          placeholder="جستجوی کارشناس..."
          value={term}
          onChange={(e: any) => setTerm(e.target.value)}
          onKeyDown={(e: any) => e.stopPropagation()}
          onClick={(e: any) => e.stopPropagation()}
        />
        {term ? (
          <IoMdClose
            className="erjaa-menu-search-clear"
            onClick={() => setTerm("")}
          />
        ) : null}
      </div>
      <div className="erjaa-menu-list">
        {filtered.length > 0 ? (
          filtered.map((item: any) => (
            <div
              key={item.id}
              className="erjaa-menu-item"
              onClick={() => onAssign(item)}
            >
              <span className="erjaa-menu-item-avatar">
                {item?.title?.charAt(0)}
              </span>
              <span className="erjaa-menu-item-name">{item?.title}</span>
              <span className="erjaa-menu-item-go">ارجاع</span>
            </div>
          ))
        ) : (
          <div className="erjaa-menu-empty">کارشناسی یافت نشد</div>
        )}
      </div>
    </Menu>
  );
}

class DetailsTicket extends DetailsTicketController {
  componentDidMount() {
    this.getCategoryList();

    if (this.ref && this.ref.current) {
      this.ref.current?.lastElementChild?.scrollIntoView();
    }
    this.getChatDetails();
    this.getAssignPersonsList();
    const searchParams = new URLSearchParams(window.location.search);
    let filters: any = {
      page: 1,
      subject: "",
      sender: "",
      receiver: "",
      from_date: null,
      to_date: null,
      deal_state: "",
      ticket_state: "",
      seen: "",
      lead_state: "",
    };
    searchParams.forEach((value, key) => {
      filters[key] = value;
    });
    sessionStorage.setItem("filters", JSON.stringify(filters));
  }
  render() {
    const {
      chatDetails,
      imagePreview,
      descriptions,
      description,
      msg,
      subject,
      assignLoading,
      assgin_to_id,
      estimatePremium,
      files,
      to_date,
      errorTask,
      endDate,
      insuranceTitle,
      productTitle,
      openAddToDealModal,
      member,
      membersList,
      addEndDate,
      newCompletionData,
      insuranceList,
      productList,
      leadsModelList,
      lead,
      openCompletionModal,
      stage,
      stagesList,
      openEditModal,
      completionData,
      endInsuranceModal,
      insuranceEndData,
      changeLeadStateModal,
      state,
      statesList,
      openChangeDealStageModal,
      openChangeDealStateModal,
      dealStage,
      dealState,
      dealStagesList,
      dealStatesList,
      sendPlan,
      categoryList,
      category_id,
      person_name,
      mobile,
      errorsList,
      sendPlanLoading,
    } = this.state;
    return (
      <Layout title="ارسال تیکت  ">
        <Helmet>
          <title>ارسال تیکت | سامانه مشتریان</title>
        </Helmet>
        <div className="details-ticket">
          <div className="details-ticket-header">
            <div className="header-top-row">
              <span className="ticket-id-badge">
                <FaTicketAlt /> تیکت شماره {chatDetails?.id}
                <span className="ticket-state-chip">
                  {chatDetails?.state_title || "در حال بررسی"}
                </span>
              </span>
              <div className="action">
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState: any) => (
                  <>
                    <Button
                      className="amaliat-btn"
                      variant="outlined"
                      {...bindTrigger(popupState)}
                    >
                      عملیات
                    </Button>
                    <Menu {...bindMenu(popupState)}>
                      {/* <MenuItem onClick={() => this.handleOpenPlanModal()}>ارسال طرح</MenuItem> */}

                      {chatDetails?.deal_id ? (
                        <>
                          <MenuItem
                            onClick={() =>
                              this.setState({
                                openTaskModal: !this.state.openTaskModal,
                                anchorEl: null,
                              })
                            }
                          >
                            افزودن پیگیری در تقویم
                          </MenuItem>
                          <MenuItem
                            onClick={() => this.handleOpenDealStageModal()}
                          >
                            تغییر مرحله
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              this.handleOpenDealStateModal();
                            }}
                          >
                            تغییر وضعیت معامله
                          </MenuItem>

                          <MenuItem onClick={() => this.handleCompletion()}>
                            تکمیل اطلاعات{" "}
                          </MenuItem>
                          <MenuItem
                            onClick={() => this.handleEndInsuranceModal()}
                          >
                            تاریخ اتمام بیمه نامه
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              this.handleChangeLeadState();
                            }}
                          >
                            تغییر وضعیت سرنخ
                          </MenuItem>
                        </>
                      ) : chatDetails?.lead_id ? (
                        <>
                          <MenuItem
                            onClick={() =>
                              this.setState({
                                openTaskModal: !this.state.openTaskModal,
                                anchorEl: null,
                              })
                            }
                          >
                            افزودن پیگیری در تقویم
                          </MenuItem>
                          <MenuItem onClick={() => this.handleCompletion()}>
                            تکمیل اطلاعات{" "}
                          </MenuItem>
                          <MenuItem
                            onClick={() => this.handleEndInsuranceModal()}
                          >
                            تاریخ اتمام بیمه نامه
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              this.handleOpenAddLeadModal();
                            }}
                          >
                            افزودن به معامله
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              this.handleChangeLeadState();
                            }}
                          >
                            تغییر وضعیت سرنخ
                          </MenuItem>
                        </>
                      ) : (
                        <MenuItem
                          onClick={() =>
                            this.setState({
                              openTaskModal: !this.state.openTaskModal,
                              anchorEl: null,
                            })
                          }
                        >
                          افزودن پیگیری در تقویم
                        </MenuItem>
                      )}
                    </Menu>
                  </>
                )}
              </PopupState>
              <button
                type="button"
                className="back-btn"
                title="بازگشت"
                onClick={() => this.gotToTickets()}
              >
                <IoIosArrowRoundBack />
              </button>
              </div>
            </div>
            <div className="title-row">
              <span className="subject-label">عنوان:</span>
              <h2 className="subject-title">{chatDetails?.subject}</h2>
            </div>
          </div>

          <div className="chat-container">
            <div className="scrollbar scroll-behavior" ref={this.ref}>
              {chatDetails?.items?.map((item: any, index: number) => {
                return (
                  <ChatItem
                    day={item?.date}
                    hour={item?.time}
                    files={item?.files}
                    mine={item?.type === "question" ? false : true}
                    applicant={item?.applicant}
                    data={item?.to_date}
                    text={item?.text}
                  />
                );
              })}
            </div>
            <div className="chat-container-send hide-mobile">
              <div
                className="chat-composer"
                onClick={(e: any) => {
                  if (e.target.closest(".chat-composer-icon, .chat-composer-send"))
                    return;
                  this.msgInputRef.current?.focus();
                }}
              >
                {Array.isArray(files) && files.length > 0 && (
                  <div className="chat-composer-files">
                    {files.map((file: any, index: number) => {
                      const isImage = file?.type?.startsWith("image/");
                      const previewUrl = isImage
                        ? file?._preview ||
                          (file._preview = URL.createObjectURL(file))
                        : null;
                      return (
                        <div
                          className="chat-composer-file"
                          key={index}
                          onClick={() =>
                            isImage
                              ? this.setState({ imagePreview: previewUrl })
                              : downloadFile(file)
                          }
                        >
                          {isImage ? (
                            <img
                              className="chat-composer-file-thumb"
                              src={previewUrl}
                              alt=""
                            />
                          ) : (
                            <span className="chat-composer-file-icon">
                              <FaFileAlt />
                            </span>
                          )}
                          <button
                            className="chat-composer-file-remove"
                            title="حذف فایل"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (file?._preview) {
                                URL.revokeObjectURL(file._preview);
                              }
                              this.removeFile(index);
                            }}
                          >
                            <IoMdClose />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="chat-composer-row">
                  <div className="chat-composer-attach">
                    <Tooltip title="ضمیمه" placement="top">
                      <label
                        htmlFor="chat-file-input-desktop"
                        className="chat-composer-icon"
                      >
                        <FaPaperclip />
                      </label>
                    </Tooltip>
                  </div>
                  <textarea
                    value={msg}
                    onChange={(e: any) => this.setState({ msg: e.target.value })}
                    className="text-area"
                    placeholder="پیام خود را اینجا بنویسید"
                    rows={1}
                    ref={this.msgInputRef}
                  />
                  <div className="chat-composer-actions">
                    <PopupState variant="popover" popupId="erjaa-menu-desktop">
                      {(popupState: any) => (
                        <>
                          <Tooltip title="ارجاع" placement="top">
                            <span
                              className="chat-composer-icon"
                              {...bindTrigger(popupState)}
                            >
                              <IoRepeatOutline />
                            </span>
                          </Tooltip>
                          <ErjaaMenu
                            open={popupState.isOpen}
                            onClose={popupState.close}
                            anchorEl={popupState.anchorEl}
                            assignPersonsList={this.state.assignPersonsList}
                            onAssign={(item: any) => {
                              popupState.close();
                            this.assignTo(item.id);
                            }}
                          />
                        </>
                      )}
                    </PopupState>
                    <Tooltip title="ارسال" placement="top">
                      <span
                        className="chat-composer-send"
                        onClick={() => this.sendAnswer()}
                      >
                        <img src={Send2} alt="ارسال" />
                      </span>
                    </Tooltip>
                  </div>
                </div>
                <input
                  id="chat-file-input-desktop"
                  style={{ display: "none" }}
                  type="file"
                  multiple
                  onChange={(event) => this.uploadFiles(event)}
                />
              </div>
            </div>
            <div className="chat-container-send hide-desktop">
              <div
                className="chat-composer"
                onClick={(e: any) => {
                  if (e.target.closest(".chat-composer-icon, .chat-composer-send"))
                    return;
                  this.msgMobileInputRef.current?.focus();
                }}
              >
                {Array.isArray(files) && files.length > 0 && (
                  <div className="chat-composer-files">
                    {files.map((file: any, index: number) => {
                      const isImage = file?.type?.startsWith("image/");
                      const previewUrl = isImage
                        ? file?._preview ||
                          (file._preview = URL.createObjectURL(file))
                        : null;
                      return (
                        <div
                          className="chat-composer-file"
                          key={index}
                          onClick={() =>
                            isImage
                              ? this.setState({ imagePreview: previewUrl })
                              : downloadFile(file)
                          }
                        >
                          {isImage ? (
                            <img
                              className="chat-composer-file-thumb"
                              src={previewUrl}
                              alt=""
                            />
                          ) : (
                            <span className="chat-composer-file-icon">
                              <FaFileAlt />
                            </span>
                          )}
                          <button
                            className="chat-composer-file-remove"
                            title="حذف فایل"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (file?._preview) {
                                URL.revokeObjectURL(file._preview);
                              }
                              this.removeFile(index);
                            }}
                          >
                            <IoMdClose />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="chat-composer-row">
                  <div className="chat-composer-attach">
                    <Tooltip title="ضمیمه" placement="top">
                      <label
                        htmlFor="chat-file-input-mobile"
                        className="chat-composer-icon"
                      >
                        <FaPaperclip />
                      </label>
                    </Tooltip>
                  </div>
                  <textarea
                    value={msg}
                    onChange={(e: any) => this.setState({ msg: e.target.value })}
                    className="text-area"
                    placeholder="پیام خود را اینجا بنویسید"
                    rows={1}
                    ref={this.msgMobileInputRef}
                  />
                  <div className="chat-composer-actions">
                    <PopupState variant="popover" popupId="erjaa-menu-mobile">
                      {(popupState: any) => (
                        <>
                          <Tooltip title="ارجاع" placement="top">
                            <span
                              className="chat-composer-icon"
                              {...bindTrigger(popupState)}
                            >
                              <IoRepeatOutline />
                            </span>
                          </Tooltip>
                          <ErjaaMenu
                            open={popupState.isOpen}
                            onClose={popupState.close}
                            anchorEl={popupState.anchorEl}
                            assignPersonsList={this.state.assignPersonsList}
                            onAssign={(item: any) => {
                              popupState.close();
                              this.assignTo(item.id);
                            }}
                          />
                        </>
                      )}
                    </PopupState>
                    <Tooltip title="ارسال" placement="top">
                      <span
                        className="chat-composer-send"
                        onClick={() => this.sendAnswer()}
                      >
                        <img src={Send2} alt="ارسال" />
                      </span>
                    </Tooltip>
                  </div>
                </div>
                <input
                  id="chat-file-input-mobile"
                  style={{ display: "none" }}
                  type="file"
                  multiple
                  onChange={(event) => this.uploadFiles(event)}
                />
              </div>
            </div>
          </div>
        </div>

        <CustomModal
          myStyle="assign-modal add-task-modal custom-modal-overflow-hidden"
          openModal={this.state.openTaskModal}
          onClose={() =>
            this.setState({
              openTaskModal: !this.state.openTaskModal,
              errorTask: [],
              to_date: "",
              subject: "",
              descriptions: "",
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <div>
                <h1 className="title">افزودن تقویم</h1>
              </div>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() =>
                  this.setState({ openTaskModal: !this.state.openTaskModal })
                }
              />
            </div>
            <div className="custom-modal-content">
            <div className="custom-modal-body">
              <div className="custom-modal-row">
                <Input
                  error={
                    errorTask.filter(
                      (name: { path: string }) => name.path === "subject",
                    )?.[0]?.errors?.[0]
                  }
                  myStyle="custom-modal-item w-100"
                  title="عنوان  "
                  value={subject}
                  onChange={(e: any) =>
                    this.setState({ subject: e.target.value })
                  }
                  emptyState={() => this.setState({ subject: "" })}
                />
              </div>
              <div className="custom-modal-row">
                <DatePicker
                  ref={this.datePickerRef}
                  render={
                    <CustomInput
                      title=" تاریخ"
                      error={
                        errorTask.filter(
                          (name: { path: string }) => name.path === "to_date",
                        )?.[0]?.errors?.[0]
                      }
                      emptyState={() => this.setState({ to_date: "" })}
                    />
                  }
                  value={to_date}
                  dateSeparator=" تا "
                  calendar={persian}
                  locale={persian_fa}
                  placeholder="  تاریخ "
                  containerClassName="custom-modal-item filter-date-container w-100"
                  inputClass="custom-date-input"
                  calendarPosition="bottom-right"
                  onChange={this.handleChangeDate}
                />
              </div>
              <div className="custom-modal-row">
                <Textarea
                  error={
                    errorTask.filter(
                      (name: { path: string }) => name.path === "descriptions",
                    )?.[0]?.errors?.[0]
                  }
                  myStyle="custom-modal-item w-100"
                  placeholder=" توضیحات "
                  value={descriptions}
                  onChange={(e: any) =>
                    this.setState({ descriptions: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="تایید و ثبت"
                loading={this.state.isAddingTask}
                onClick={() => this.addTask()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        <CustomModal
          myStyle="assign-modal add-task-modal"
          openModal={openAddToDealModal}
          onClose={() =>
            this.setState({
              openAddToDealModal: !openAddToDealModal,
              errorTask: [],
              lead: "",
              member: "",
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <div>
                <h1 className="title">افزودن سرنخ به مدل معامله</h1>
              </div>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() =>
                  this.setState({
                    openAddToDealModal: !openAddToDealModal,
                    errorTask: [],
                    lead: "",
                    member: "",
                    stage: "",
                    description: "",
                    estimatePremium: "",
                  })
                }
              />
            </div>
            <div className="custom-modal-content">
            <div className="custom-modal-body">
              <div className="custom-modal-row">
                <Dropdown
                  placeholder="یک گزینه را انتخاب کنید"
                  items={leadsModelList}
                  objectList
                  myStyle=" w-100 custom-modal-item"
                  error={
                    errorTask.filter(
                      (name: { path: string }) => name.path === "lead",
                    )?.[0]?.errors?.[0]
                  }
                  title="مدل معامله"
                  value={lead}
                  onChange={(e: any) => this.handleDealChange(e)}
                  emptyState={() => this.setState({ lead: "" })}
                >
                  {leadsModelList &&
                    leadsModelList?.map((item: any, index: number) => {
                      return (
                        <MenuItem value={item?.id} key={index}>
                          {item?.subject}
                        </MenuItem>
                      );
                    })}
                </Dropdown>
              </div>
              <div className="custom-modal-row">
                <Dropdown
                  placeholder="یک گزینه را انتخاب کنید"
                  items={stagesList}
                  objectList
                  myStyle="custom-modal-item w-100"
                  error={
                    errorTask.filter(
                      (name: { path: string }) => name.path === "stage",
                    )?.[0]?.errors?.[0]
                  }
                  title="مرحله"
                  value={stage}
                  onChange={(e: any) => {
                    this.setState({ stage: e.target.value });
                  }}
                  emptyState={() => this.setState({ stage: "" })}
                >
                  {stagesList &&
                    stagesList?.map((item: any, index: number) => {
                      return (
                        <MenuItem value={item?.id} key={index}>
                          {item?.title}
                        </MenuItem>
                      );
                    })}
                </Dropdown>
              </div>
              <div className="custom-modal-row">
                <Dropdown
                  placeholder="یک گزینه را انتخاب کنید"
                  items={membersList}
                  objectList
                  myStyle=" w-100 custom-modal-item"
                  error={
                    errorTask.filter(
                      (name: { path: string }) => name.path === "member",
                    )?.[0]?.errors?.[0]
                  }
                  title="مسئول"
                  value={member}
                  onChange={(e: any) => {
                    this.setState({ member: e.target.value });
                  }}
                  emptyState={() => this.setState({ member: "" })}
                >
                  {membersList &&
                    membersList?.map((item: any, index: number) => {
                      return (
                        <MenuItem value={item?.id} key={index}>
                          {item?.title}
                        </MenuItem>
                      );
                    })}
                </Dropdown>
              </div>
              <div className="custom-modal-row">
                <Input
                  myStyle="w-100 custom-modal-item"
                  type="number"
                  title="تخمین حق بیمه"
                  value={estimatePremium}
                  onChange={(e: any) =>
                    this.setState({ estimatePremium: e.target.value })
                  }
                  emptyState={() => this.setState({ estimatePremium: "" })}
                />
              </div>
              <div className="custom-modal-row">
                <Input
                  myStyle="w-100 custom-modal-item"
                  rows={4}
                  multiline={true}
                  title="توضیحات"
                  value={description}
                  onChange={(e: any) =>
                    this.setState({ description: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="تایید و ثبت"
                loading={this.state.isAssigningToDealModel}
                onClick={() => this.handleSendDealModel()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        <CustomModal
          myStyle="assign-modal custom-modal-overflow-hidden"
          openModal={openCompletionModal}
          onClose={() =>
            this.setState({
              openCompletionModal: !openCompletionModal,
              completionData: {},
              insuranceEndData: [],
              newCompletionData: {},
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <div>
                <h1 className="title">تکمیل اطلاعات</h1>
              </div>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() =>
                  this.setState({
                    openCompletionModal: !openCompletionModal,
                    completionData: {},
                    newCompletionData: {},
                    insuranceEndData: [],
                  })
                }
              />
            </div>
            <div className="custom-modal-content">
            <div className="custom-modal-body">
              {Object.keys(completionData).map((key, index: number) => (
                <div className="custom-modal-row">
                  {completionData[key]?.type === "text_area" ? (
                    <Input
                      rows={3}
                      multiline
                      key={key}
                      name={key}
                      myStyle="custom-modal-item mb-75 w-100"
                      title={completionData[key].title}
                      value={completionData[key].value}
                      onChange={(e: any) =>
                        this.handleChangeCompletionData(key, e.target.value)
                      }
                    />
                  ) : completionData[key]?.type === "text" ? (
                    <Input
                      key={key}
                      type="text"
                      name={key}
                      myStyle={`custom-modal-item w-100`}
                      title={completionData[key].title}
                      value={completionData[key].value}
                      onChange={(e: any) =>
                        this.handleChangeCompletionData(key, e.target.value)
                      }
                    />
                  ) : completionData[key]?.type === "int" ? (
                    <Input
                      key={key}
                      type="number"
                      name={key}
                      myStyle={`custom-modal-item w-100`}
                      title={completionData[key].title}
                      value={completionData[key].value}
                      onChange={(e: any) =>
                        this.handleChangeCompletionData(key, e.target.value)
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              ))}
              <span className="end-date-span">تاریخ‌های پایان</span>
              <List
                sx={{
                  py: 0,
                  width: "100%",
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: "divider",
                }}
                aria-label="mailbox folders"
              >
                {insuranceEndData.length > 0 &&
                  insuranceEndData.map((item: any, index: number) => {
                    return (
                      <>
                        <ListItem>
                          <ListItemText
                            sx={{ width: "30%" }}
                            primary={item?.product_title}
                          />
                          <ListItemText
                            sx={{ width: "30%" }}
                            primary={item?.insurance_title}
                          />
                          <ListItemText
                            sx={{ width: "30%" }}
                            primary={item?.end_date}
                          />
                        </ListItem>
                        <Divider component="li" />
                      </>
                    );
                  })}
              </List>
            </div>
            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="ویرایش"
                loading={this.state.isEditingCompletion}
                onClick={() => this.handleEditCompletion()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        <CustomModal
          myStyle={`assign-modal${
            addEndDate ? " d-flex flex-column justify-content-between" : ""
          }`}
          size="lg"
          openModal={endInsuranceModal}
          onClose={() =>
            this.setState({
              endInsuranceModal: !endInsuranceModal,
              addEndDate: false,
              insuranceTitle: "",
              endDate: "",
              finalEndDate: "",
              productTitle: "",
              errorTask: [],
            })
          }
        >
          <>
            {addEndDate ? (
              <>
                <div className="custom-modal-main-title mb-2">
                  <div>
                    <h1 className="title">افزودن بیمه‌نامه</h1>
                  </div>
                  <div className="flex-gapped-column">
                    <Cancel
                      myStyle="ps-2 "
                      width="20"
                      height="20"
                      color="#000000"
                      onClick={() => this.handleBackFromAddEndDate()}
                    />
                  </div>
                </div>
                <div className="custom-modal-content">
                <div className="custom-modal-row">
                    <Dropdown
                      error={
                        errorTask.filter(
                          (name: { path: string }) =>
                            name.path === "insuranceTitle",
                        )?.[0]?.errors?.[0]
                      }
                      placeholder="یک گزینه را انتخاب کنید"
                      items={insuranceList}
                      objectList
                      myStyle=" w-100"
                      title="بیمه"
                      value={insuranceTitle}
                      onChange={(e: any) => {
                        this.setState({ insuranceTitle: e.target.value });
                      }}
                      emptyState={() => this.setState({ insuranceTitle: "" })}
                    >
                      {insuranceList &&
                        insuranceList?.map((item: any, index: number) => {
                          return (
                            <MenuItem value={item} key={index}>
                              {item}
                            </MenuItem>
                          );
                        })}
                    </Dropdown>
                  </div>
                  <div className="custom-modal-row">
                    <DatePicker
                      ref={this.datePickerRef}
                      containerClassName="custom-modal-item filter-date-container w-100"
                      inputClass="custom-date-input"
                      calendarPosition="bottom-right"
                      format={END_DATE_FORMAT}
                      value={endDate}
                      minDate={new Date()}
                      onChange={(date: any) => {
                        this.handleChangeEndDate(date);
                      }}
                      render={
                        <EndDateInput
                          title="تاریخ اتمام"
                          error={
                            errorTask.filter(
                              (name: { path: string }) =>
                                name.path === "endDate",
                            )?.[0]?.errors?.[0]
                          }
                        />
                      }
                      placeholder={END_DATE_FORMAT}
                      calendar={persian}
                      locale={persian_fa}
                    />
                  </div>
                  <div className="custom-modal-row ">
                    <Dropdown
                      error={
                        errorTask.filter(
                          (name: { path: string }) =>
                            name.path === "productTitle",
                        )?.[0]?.errors?.[0]
                      }
                      placeholder="یک گزینه را انتخاب کنید"
                      items={productList}
                      objectList
                      myStyle=" w-100"
                      title="محصول"
                      value={productTitle}
                      onChange={(e: any) => {
                        this.setState({ productTitle: e.target.value });
                      }}
                      emptyState={() => this.setState({ productTitle: "" })}
                    >
                      {productList &&
                        productList?.map((item: any, index: number) => {
                          return (
                            <MenuItem value={item} key={index}>
                              {item}
                            </MenuItem>
                          );
                        })}
                    </Dropdown>
                  </div>
                </div>
                <div className="custom-modal-confirm">
                  <MyButton
                    myStyle="bg-green"
                    title="افزودن"
                    loading={this.state.isAddingEndDate}
                    onClick={() => this.addEndDate()}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="custom-modal-main-title mb-2">
                  <div>
                    <h1 className="title">تاریخ اتمام بیمه‌نامه</h1>
                  </div>
                  <div className="flex-gapped-column align-items-end">
                    <Cancel
                      myStyle="ps-2 "
                      width="20"
                      height="20"
                      color="#000000"
                      onClick={() =>
                        this.setState({
                          endInsuranceModal: !endInsuranceModal,
                          addEndDate: false,
                        })
                      }
                    />
                    <MyButton
                      myStyle="bg-green"
                      title="افزودن"
                      icon={<IoAddSharp className="ms-2" />}
                      onClick={() => this.setState({ addEndDate: true })}
                    />
                  </div>
                </div>
                <div className="custom-modal-content">
                {insuranceEndData.length > 0 && (
                  <List
                    sx={{
                      py: 0,
                      width: "100%",
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                    aria-label="mailbox folders"
                  >
                    {insuranceEndData.map((item: any, index: number) => {
                      return (
                        <>
                          <ListItem>
                            <ListItemText
                              sx={{ width: "30%" }}
                              primary={item?.product_title}
                            />
                            <ListItemText
                              sx={{ width: "30%" }}
                              primary={item?.insurance_title}
                            />
                            <ListItemText
                              sx={{ width: "30%" }}
                              primary={item?.end_date}
                            />
                          </ListItem>

                          <Divider component="li" />
                        </>
                      );
                    })}
                  </List>
                )}
                </div>
              </>
            )}
          </>
        </CustomModal>
        <CustomModal
          myStyle="one-field-modal"
          openModal={openChangeDealStageModal}
          onClose={() =>
            this.setState({
              openChangeDealStageModal: !openChangeDealStageModal,
              errorTask: [],
              dealStage: "",
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <div>
                <h1 className="title">تغییر مرحله معامله</h1>
              </div>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() =>
                  this.setState({
                    openChangeDealStageModal: !openChangeDealStageModal,
                    errorTask: [],
                    dealStage: "",
                  })
                }
              />
            </div>

            <div className="custom-modal-content">
            <div className="custom-modal-row">
              <Dropdown
                placeholder="یک گزینه را انتخاب کنید"
                items={dealStagesList}
                objectList
                myStyle=" w-100"
                error={
                  errorTask.filter(
                    (name: { path: string }) => name.path === "dealStage",
                  )?.[0]?.errors?.[0]
                }
                title="مرحله "
                value={dealStage}
                onChange={(e: any) => {
                  this.setState({ dealStage: e.target.value });
                }}
                emptyState={() => this.setState({ dealStage: "" })}
              >
                {dealStagesList &&
                  dealStagesList?.map((item: any, index: number) => {
                    return (
                      <MenuItem value={item?.id} key={index}>
                        {item?.title}
                      </MenuItem>
                    );
                  })}
              </Dropdown>
            </div>
            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="تایید و ثبت"
                loading={this.state.isChangingDealStage}
                onClick={() => this.handleChangeStage()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        <CustomModal
          myStyle="one-field-modal"
          openModal={openChangeDealStateModal}
          onClose={() =>
            this.setState({
              openChangeDealStateModal: !openChangeDealStateModal,
              errorTask: [],
              dealState: "",
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <div>
                <h1 className="title">تغییر وضعیت معامله</h1>
              </div>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() =>
                  this.setState({
                    openChangeDealStateModal: !openChangeDealStateModal,
                    errorTask: [],
                    dealState: "",
                  })
                }
              />
            </div>

            <div className="custom-modal-content">
            <div className="custom-modal-row">
              <Dropdown
                placeholder="یک گزینه را انتخاب کنید"
                items={dealStatesList}
                objectList
                myStyle=" w-100"
                error={
                  errorTask.filter(
                    (name: { path: string }) => name.path === "dealState",
                  )?.[0]?.errors?.[0]
                }
                title="وضعیت "
                value={dealState}
                onChange={(e: any) => {
                  this.setState({ dealState: e.target.value });
                }}
                emptyState={() => this.setState({ dealState: "" })}
              >
                {dealStatesList &&
                  dealStatesList?.map((item: any, index: number) => {
                    return (
                      <MenuItem value={item?.name} key={index}>
                        {item?.title}
                      </MenuItem>
                    );
                  })}
              </Dropdown>
            </div>
            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="تایید و ثبت"
                loading={this.state.isChangingDealState}
                onClick={() => this.handleSendDealState()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        <CustomModal
          myStyle="one-field-modal"
          openModal={changeLeadStateModal}
          onClose={() =>
            this.setState({
              changeLeadStateModal: !openEditModal,
              state: "",
              errorTask: [],
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <h1 className="custom-modal-title">ویرایش وضعیت</h1>
              <Cancel
                myStyle="ps-2 cursor-pointer"
                color="#000000"
                onClick={() =>
                  this.setState({
                    changeLeadStateModal: !changeLeadStateModal,
                    state: "",
                    errorTask: [],
                  })
                }
              />
            </div>
            <div className="custom-modal-content">
            <div className="custom-modal-row ">
              <Dropdown
                placeholder="یک گزینه را انتخاب کنید"
                items={statesList}
                objectList
                myStyle=" w-100"
                title="وضعیت"
                value={state}
                onChange={(e: any) => {
                  this.setState({ state: e.target.value });
                }}
                emptyState={() => this.setState({ state: "" })}
                error={
                  errorTask.filter(
                    (name: { path: string }) => name.path === "state",
                  )?.[0]?.errors?.[0]
                }
              >
                {statesList &&
                  statesList?.map((item: any, index: number) => {
                    return (
                      <MenuItem value={item?.id} key={index}>
                        {item?.title}
                      </MenuItem>
                    );
                  })}
              </Dropdown>
            </div>

            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="اعمال"
                loading={this.state.isChangingLeadState}
                onClick={() => this.changeState()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        <CustomModal
          myStyle="assign-modal custom-modal-overflow-hidden"
          openModal={sendPlan}
          size="lg"
          onClose={() =>
            this.setState({
              sendPlan: !sendPlan,
              errorsList: [],
              sendPlanLoading: false,
              person_name: "",
              category_id: "",
              mobile: "",
            })
          }
        >
          <>
            <div className="custom-modal-main-title mb-2">
              <div>
                <h1 className="title">ارسال طرح</h1>
              </div>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() =>
                  this.setState({
                    sendPlan: !sendPlan,
                    errorsList: [],
                    sendPlanLoading: false,
                    person_name: "",
                    category_id: "",
                    mobile: "",
                  })
                }
              />
            </div>
            <div className="custom-modal-content">
            <div className="custom-modal-body">
              <div className="custom-modal-row cols-1">
                <Input
                  error={
                    errorsList.filter(
                      (name: { path: string }) => name.path === "person_name",
                    )?.[0]?.errors?.[0]
                  }
                  title="نام"
                  myStyle=""
                  value={person_name}
                  onChange={(e: any) => {
                    this.setState({ person_name: e.target.value });
                  }}
                />
                <Input
                  error={
                    errorsList.filter(
                      (name: { path: string }) => name.path === "mobile",
                    )?.[0]?.errors?.[0]
                  }
                  title="موبایل"
                  myStyle=""
                  value={mobile}
                  onChange={(e: any) => {
                    this.setState({ mobile: e.target.value });
                  }}
                />
                <Dropdown
                  title=" دسته بندی "
                  items={categoryList}
                  error={
                    errorsList.filter(
                      (name: { path: string }) => name.path === "category_id",
                    )?.[0]?.errors?.[0]
                  }
                  myStyle=""
                  emptyState={() => this.setState({ category_id: "" })}
                  value={category_id}
                  onChange={(e: any) => {
                    this.setState({ category_id: e.target.value });
                  }}
                >
                  {categoryList &&
                    categoryList?.map((item: any, index: number) => {
                      return (
                        <MenuItem value={item?.id} key={index}>
                          {item?.title}
                        </MenuItem>
                      );
                    })}
                </Dropdown>
              </div>
            </div>
            <div className="custom-modal-confirm">
              <MyButton
                myStyle="bg-green"
                title="ارسال طرح"
                loading={this.state.sendPlanLoading}
                onClick={() => this.sendPlan()}
              />
            </div>
            </div>
          </>
        </CustomModal>
        {imagePreview && (
          <div
            className="chat-image-preview"
            onClick={() => this.setState({ imagePreview: null })}
          >
            <button
              className="chat-image-preview-close"
              onClick={() => this.setState({ imagePreview: null })}
            >
              <IoMdClose />
            </button>
            <img src={imagePreview} alt="پیش‌نمایش" />
          </div>
        )}
      </Layout>
    );
  }
}

export default DetailsTicket;
